import { DefaultService } from '@/services/DefaultService';

export default class AssuntoRtrService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    save(assuntortr, contexto = "agro") {
        return this._http.post(`${this._env}/${contexto}/assuntortr`, assuntortr, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id, contexto = "agro") {
        return this._http.get(`${this._env}/${contexto}/assuntortr/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/agro/assuntortr/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(column = 'descricao', order = 'asc', page = 0, limit = 50, situacao = 2, contexto = "agro", ...params) {
        return this._http.get(encodeURI(`${this._env}/${contexto}/assuntortr.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    listAllByMultipleIdsTipoVisita(idsTipoVisita, limit = 50, page = 0, situacao = 2, ...params) {
        return this._http.post(`${this._env}/agro/assuntortr/listbymultipletipovisita.json?limit=${limit}&page=${page}&situacao=${situacao}&param=${params}`, idsTipoVisita, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    changeSituacao(id, situacao) {
        return this._http.get(`${this._env}/agro/assuntortr/activate/${id}?situacao=${situacao}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(assuntortr, contexto = "agro") {
        return this._http.post(`${this._env}/${contexto}/assuntortr/updatesituacao`, assuntortr, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllCombo(params) {
        return this.findAllComboSituacao(1, params)
    }
    findAllComboSituacao(situacao = 1,  ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/assuntortr/getcombo.json?situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}